export default "__VITE_ASSET__Cob5nIuD__"